import React, { useEffect, useMemo } from "react";
import { CDataTable } from "@coreui/react";
import { Center, Spinner, Box } from "@chakra-ui/react";
import { getSlots } from "./DataTable.hooks";
import { DataTableProps } from "./DataTable.type";
import Healing from "./Healing";

const DataTable: React.FC<DataTableProps> = ({
  fields,
  items,
  putEndpoint,
  loading = false,
  ...props
}) => {
  const itemsWithWarning = useMemo(
    () =>
      items.map((item) => {
        const newItem = { ...item };
        if (
          item.videoUrl === "" ||
          item.mediaUrl === "" ||
          item.imageUrl === ""
        ) {
          newItem._classes = "table-danger";
        }
        return newItem;
      }),
    [items]
  );
  const [timer, setTimer] = React.useState(false);
  const slots = useMemo(
    () =>
      getSlots({
        putEndpoint,
        ...props,
      }),
    [putEndpoint, props]
  );
  useEffect(() => {
    if (loading) {
      setTimer(false);
      return;
    }
    const timeoutId = window.setTimeout(() => {
      setTimer(true);
    }, 500);
    return () => window.clearTimeout(timeoutId);
  }, [itemsWithWarning.length, loading]);
  const dataProps = useMemo(() => {
    return {
      fields,
      items: itemsWithWarning,
      scopedSlots: slots,
    };
  }, [fields, itemsWithWarning, slots]);
  return (
    <Box className="bg-white p-3" borderRadius="5px" color="#3c4b64">
      {putEndpoint.split("/")[0] === "healing" ? (
        <Healing {...dataProps} />
      ) : itemsWithWarning.length > 0 ? (
        <CDataTable {...dataProps} />
      ) : loading ? (
        <Center height={"50vh"}>
          <Spinner size={"xl"} />
        </Center>
      ) : timer ? (
        <p>No data</p>
      ) : (
        <Center height={"50vh"}>
          <Spinner size={"xl"} />
        </Center>
      )}
    </Box>
  );
};

export default DataTable;
